
var id = "weixinMiniApp";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"weixinMiniApp\">\n<g clip-path=\"url(#weixinMiniApp_clip0_1262_52112)\">\n<path d=\"M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31777 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31777 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663Z\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M9.66651 7.99935C9.99614 7.99935 10.3184 7.90162 10.5925 7.71848C10.8665 7.53532 11.0802 7.27502 11.2063 6.97049C11.3324 6.66595 11.3655 6.33085 11.3011 6.00755C11.2368 5.68422 11.0781 5.38725 10.845 5.15419C10.6119 4.92109 10.315 4.76235 9.99167 4.69805C9.66834 4.63372 9.33324 4.66675 9.02871 4.79288C8.72417 4.91902 8.46387 5.13265 8.28074 5.40675C8.09757 5.68082 7.99984 6.00305 7.99984 6.33268V9.66602C7.99984 9.99565 7.90211 10.3179 7.71897 10.592C7.53581 10.8661 7.27554 11.0797 6.97097 11.2058C6.66644 11.332 6.33134 11.365 6.00804 11.3007C5.68471 11.2364 5.38774 11.0776 5.15467 10.8445C4.92157 10.6115 4.76284 10.3145 4.69854 9.99119C4.63421 9.66785 4.66724 9.33275 4.79337 9.02822C4.91951 8.72368 5.13314 8.46338 5.40724 8.28025C5.68131 8.09708 6.00354 7.99935 6.33317 7.99935\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n</g>\n<defs>\n<clipPath id=\"weixinMiniApp_clip0_1262_52112\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
